import clsx from "clsx";
import { helpers } from "../util/helpers.ts";
import i18n from "../util/i18n.ts";

export type DataDomainView = "leaders" | "playerStats" | "playerRatings" | "teamStats";

// G2e data-domain IA merge: this replaces the retired 3-tab data-center hub
// (PlayerStatsHubTabs / TeamStatsHubTabs / leagueDataCenter). The League Leaders
// page is the single converged Data entry and shows this domain nav row linking
// the four data views (leaders / player stats / player ratings / team stats);
// the other three pages carry a single "back to data" breadcrumb instead of the
// tab strip, so navigation converges here (法则二). All four routes are
// preserved for deep-linking.
const VIEWS: {
  key: DataDomainView;
  href: string[];
  label: string;
  defaultLabel: string;
}[] = [
  {
    key: "leaders",
    href: ["leaders"],
    label: "dataHub.navLeaders",
    defaultLabel: "Leaders",
  },
  {
    key: "playerStats",
    href: ["player_stats"],
    label: "dataHub.navPlayerStats",
    defaultLabel: "Player stats",
  },
  {
    key: "playerRatings",
    href: ["player_ratings"],
    label: "dataHub.navPlayerRatings",
    defaultLabel: "Player ratings",
  },
  {
    key: "teamStats",
    href: ["team_stats"],
    label: "dataHub.navTeamStats",
    defaultLabel: "Team stats",
  },
];

export const DataDomainNav = ({ activeView }: { activeView: DataDomainView }) => (
  <nav
    aria-label={i18n.t("dataHub.title", { ns: "ui", defaultValue: "Data" })}
    className="data-domain-nav mb-3"
    data-data-domain-nav=""
    data-data-domain-active-view={activeView}
  >
    <div className="d-flex flex-wrap gap-2" data-data-domain-links="">
      {VIEWS.map((view) => {
        const active = view.key === activeView;

        return (
          <a
            aria-current={active ? "page" : undefined}
            className={clsx("btn btn-sm", active ? "btn-primary" : "btn-light-bordered")}
            data-data-domain-link={view.key}
            href={helpers.leagueUrl(view.href)}
            key={view.key}
          >
            {i18n.t(view.label, { ns: "ui", defaultValue: view.defaultLabel })}
          </a>
        );
      })}
    </div>
  </nav>
);

export default DataDomainNav;
